export const cookiesStorage = {
	getItem: (key: string): string => {
		if (typeof window !== 'undefined') {
			const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
			for (const cookie of cookies) {
				const [cookieName, cookieValue] = cookie.split('=');
				if (cookieName === key) {
					return decodeURIComponent(cookieValue);
				}
			}
		}

		return '';
	},
	setItem: (key: string, value: string, daysToExpire: number = 30): void => {
		const expirationDate = new Date();
		expirationDate.setDate(expirationDate.getDate() + daysToExpire);

		const cookieValue =
			encodeURIComponent(value) +
			(daysToExpire ? `; expires=${expirationDate.toUTCString()}` : '');
		document.cookie = `${key}=${cookieValue}; path=/`;
	},
	removeItem: (key: string): void => {
		const expirationDate = new Date();
		expirationDate.setDate(expirationDate.getDate() - 1); // Đặt hạn sử dụng là hôm qua

		const cookieValue =
			encodeURIComponent('') + '; expires=' + expirationDate.toUTCString();
		document.cookie = key + '=' + cookieValue + '; path=/';
	},
};
